export const SoundIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none">
    <path
      fill="#FF0083"
      fillRule="evenodd"
      d="M3.65 10.525H2.473a.984.984 0 0 1-.985-.985V6.46c0-.544.441-.985.985-.985h.864a.984.984 0 0 0 .572-.183l3.235-2.311a.984.984 0 0 1 1.557.801v8.436a.984.984 0 0 1-1.557.801l-3.492-2.494Z"
      clipRule="evenodd"
    />
    <path
      stroke="#FF0083"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M10.505 5.818c.591.35 1.002 1.116 1.002 2.004 0 .888-.41 1.653-1.002 2.004M12.509 3.814c1.183.701 2.004 2.232 2.004 4.008 0 1.776-.821 3.307-2.004 4.008"
    />
  </svg>
);

export const DocIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none">
    <rect width={10.562} height={12.856} x={2.72} y={1.572} fill="#FF0083" rx={2} />
    <path
      stroke="#FFEBF5"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M10.294 5.365H5.707M8.528 8H5.707"
    />
  </svg>
);

export const LinkIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={17} fill="none">
    <path
      fill="#FF0083"
      fillRule="evenodd"
      d="M13.53 2.97c.075.075.131.162.168.255l.051.238.001.037v3.062a.75.75 0 0 1-1.5 0V5.312L9.53 8.03l-.604.603a.75.75 0 1 1-1.06-1.06l.604-.604 2.72-2.72H9.937a.75.75 0 0 1 0-1.5H13.002c.191 0 .382.074.528.22ZM4.247 5.247a.417.417 0 0 1 .295-.122h2.5a.75.75 0 0 0 0-1.5h-2.5a1.917 1.917 0 0 0-1.917 1.917v6.416a1.916 1.916 0 0 0 1.917 1.917h6.416a1.916 1.916 0 0 0 1.917-1.917v-2.5a.75.75 0 0 0-1.5 0v2.5a.417.417 0 0 1-.417.417H4.542a.417.417 0 0 1-.417-.417V5.542c0-.11.044-.217.122-.295Z"
      clipRule="evenodd"
    />
  </svg>
);
